import axios from 'axios';
import { config } from '../config';

const weatherService = {
    async getWeatherForecast(city, fromDate) {
        try {
            const response = await axios.get(`${config.WEATHER_API_BASE_URL}/forecast.json`, {
                params: {
                    key: config.WEATHER_API_KEY,
                    q: city,
                    days: 5,
                    dt: fromDate
                }
            });

            const forecast = response.data.forecast.forecastday[0].day;
            return `You can expect the weather to be quite ${forecast.condition.text.toLowerCase()}. 
                    Low will be ${forecast.mintemp_c}° and high will be ${forecast.maxtemp_c}°`;
        } catch (error) {
            console.error('Error getting weather forecast:', error);
            throw error;
        }
    }
};

export default weatherService;
